module.exports = __webpack_public_path__ + "static/media/gts02.de9f0e12.png";